import { createSelector } from 'reselect';

const selectFormBundleForms = ({ formBundleForms }) => formBundleForms;

export const selectFormBundleFormsValues = createSelector(selectFormBundleForms, Object.values);

export const selectUsedFormIdsToBundle = createSelector(
  [selectFormBundleFormsValues],
  formBundleForms => formBundleForms.map(({ formId }) => formId),
);
